var map = {
	"./agents-modals.json": "./src/i18n/locales/ja/agents-modals.json",
	"./agents-workflow.json": "./src/i18n/locales/ja/agents-workflow.json",
	"./charts.json": "./src/i18n/locales/ja/charts.json",
	"./common.json": "./src/i18n/locales/ja/common.json",
	"./layout.json": "./src/i18n/locales/ja/layout.json",
	"./page-agent-chat.json": "./src/i18n/locales/ja/page-agent-chat.json",
	"./page-agent-insights-selection.json": "./src/i18n/locales/ja/page-agent-insights-selection.json",
	"./page-api-endpoints.json": "./src/i18n/locales/ja/page-api-endpoints.json",
	"./page-charts.json": "./src/i18n/locales/ja/page-charts.json",
	"./page-database-connection.json": "./src/i18n/locales/ja/page-database-connection.json",
	"./page-db-understanding-settings.json": "./src/i18n/locales/ja/page-db-understanding-settings.json",
	"./page-insight-query.json": "./src/i18n/locales/ja/page-insight-query.json",
	"./page-insights-results.json": "./src/i18n/locales/ja/page-insights-results.json",
	"./page-plan-detail.json": "./src/i18n/locales/ja/page-plan-detail.json",
	"./page-query-compare.json": "./src/i18n/locales/ja/page-query-compare.json",
	"./page-query-execution.json": "./src/i18n/locales/ja/page-query-execution.json",
	"./page-query-generator.json": "./src/i18n/locales/ja/page-query-generator.json",
	"./page-report-generation.json": "./src/i18n/locales/ja/page-report-generation.json",
	"./page-schema-analysis.json": "./src/i18n/locales/ja/page-schema-analysis.json",
	"./page-settings.json": "./src/i18n/locales/ja/page-settings.json",
	"./page-subagent-queries.json": "./src/i18n/locales/ja/page-subagent-queries.json",
	"./pages-misc-1.json": "./src/i18n/locales/ja/pages-misc-1.json",
	"./pages-misc-2.json": "./src/i18n/locales/ja/pages-misc-2.json",
	"./pages-misc-3.json": "./src/i18n/locales/ja/pages-misc-3.json",
	"./pages-misc-4.json": "./src/i18n/locales/ja/pages-misc-4.json",
	"./pages-misc-5.json": "./src/i18n/locales/ja/pages-misc-5.json",
	"./query-refinement.json": "./src/i18n/locales/ja/query-refinement.json",
	"./report-design-chat.json": "./src/i18n/locales/ja/report-design-chat.json",
	"./report-panels.json": "./src/i18n/locales/ja/report-panels.json",
	"./shared-common.json": "./src/i18n/locales/ja/shared-common.json",
	"./ui-common.json": "./src/i18n/locales/ja/ui-common.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/i18n/locales/ja sync \\.json$";